import { render, staticRenderFns } from "./CurrentIntegrations.vue?vue&type=template&id=18627d01&scoped=true&"
import script from "./CurrentIntegrations.vue?vue&type=script&lang=ts&"
export * from "./CurrentIntegrations.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentIntegrations.vue?vue&type=style&index=0&id=18627d01&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18627d01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardSubtitle,VCardText,VCardTitle,VCol,VContainer,VList,VListItem,VRow,VSpacer})
